import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

import { get } from 'lodash';

export const CREATE_USER_FAILURE = 'USER_MANAGEMENT/CREATE_USER_FAILURE';
export const CREATE_USER_LOAD = 'USER_MANAGEMENT/CREATE_USER_LOAD';
export const CREATE_USER_SUCCESS = 'USER_MANAGEMENT/CREATE_USER_SUCCESS';

export const CLEAR_CREATED_USER = 'USER_MANAGEMENT/CLEAR_CREATED_USER';

export const EDIT_USER_FAILURE = 'USER_MANAGEMENT/EDIT_USER_FAILURE';
export const EDIT_USER_LOAD = 'USER_MANAGEMENT/EDIT_USER_LOAD';
export const EDIT_USER_SUCCESS = 'USER_MANAGEMENT/EDIT_USER_SUCCESS';

export const DELETE_USER_FAILURE = 'USER_MANAGEMENT/DELETE_USER_FAILURE';
export const DELETE_USER_LOAD = 'USER_MANAGEMENT/DELETE_USER_LOAD';
export const DELETE_USER_SUCCESS = 'USER_MANAGEMENT/DELETE_USER_SUCCESS';

export const USERS_FAILURE = 'USER_MANAGEMENT/USERS_FAILURE';
export const USERS_LOAD = 'USER_MANAGEMENT/USERS_LOAD';
export const USERS_SUCCESS = 'USER_MANAGEMENT/USERS_SUCCESS';

export const ROLES_FAILURE = 'USER_MANAGEMENT/ROLES_FAILURE';
export const ROLES_LOAD = 'USER_MANAGEMENT/ROLES_LOAD';
export const ROLES_SUCCESS = 'USER_MANAGEMENT/ROLES_SUCCESS';

export const fetchUrl = `${config.userManagementApiUrl}/user`;

export function createUser(merchantIds, payoutAccountIds, email, role, isApiUser) {
    return {
        failureActionTypeOrCreator: createUserFailureActionCreator,
        fetchParams: {
            body: {
                merchantIds,
                payoutAccountIds,
                email,
                role,
                isApiUser
            },
            method: 'POST',
            url: `${config.userManagementApiUrl}/account/emvioUser`
        },
        loadActionTypeOrCreator: CREATE_USER_LOAD,
        successActionTypeOrCreator: createUserSuccessActionCreator
    };
}

export function createUserFailureActionCreator(error) {
    return {
        error,
        type: CREATE_USER_FAILURE
    };
}

export function createUserSuccessActionCreator(user) {
    return {
        type: CREATE_USER_SUCCESS,
        user
    };
}

export function clearCreatedUser() {
    return { type: CLEAR_CREATED_USER };
}

export function editUser(userId, merchantIds, payoutAccountIds, role, isApiUser) {
    return {
        failureActionTypeOrCreator: editUserFailureActionCreator,
        fetchParams: {
            body: {
                userId,
                merchantIds,
                payoutAccountIds,
                role,
                isApiUser
            },
            method: 'PUT',
            url: `${config.userManagementApiUrl}/account/emvioUser`
        },
        loadActionTypeOrCreator: EDIT_USER_LOAD,
        successActionTypeOrCreator: EDIT_USER_SUCCESS
    };
}

export function editUserFailureActionCreator(error) {
    return {
        error,
        type: EDIT_USER_FAILURE
    };
}

export function deleteUser(user) {
    const email = get(user, 'username');

    return {
        failureActionTypeOrCreator: deleteUserFailureActionCreator,
        fetchParams: {
            body: {
                email
            },
            method: 'DELETE',
            url: `${config.userManagementApiUrl}/account/emvioUser`
        },
        loadActionTypeOrCreator: DELETE_USER_LOAD,
        successActionTypeOrCreator: DELETE_USER_SUCCESS
    };
}

export function deleteUserFailureActionCreator(error) {
    return {
        error,
        type: DELETE_USER_FAILURE
    };
}

export function getUsersFailureActionCreator(error) {
    return {
        error,
        type: USERS_FAILURE
    };
}

export function getUsersSuccessActionCreator(results) {
    return {
        count: results.count,
        pages: Math.ceil(results.count / results.limit),
        users: results.rows,
        type: USERS_SUCCESS
    };
}

export function getUsers(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        filters,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getUsersFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: USERS_LOAD,
        successActionTypeOrCreator: getUsersSuccessActionCreator
    };
}

export function getAvailableRolesFailureActionCreator(error) {
    return {
        error,
        type: ROLES_FAILURE
    };
}

export function getAvailableRolesSuccessActionCreator({ roles }) {
    return {
        roles,
        type: ROLES_SUCCESS
    };
}

export function getAvailableRoles() {
    return {
        failureActionTypeOrCreator: getAvailableRolesFailureActionCreator,
        fetchParams: {
            url: `${config.userManagementApiUrl}/availableRoles`
        },
        loadActionTypeOrCreator: ROLES_LOAD,
        successActionTypeOrCreator: getAvailableRolesSuccessActionCreator
    };
}
